import * as React from "react";
import type { SVGProps } from "react";
const SvgLinkedinGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 25"
    {...props}
  >
    <g clipPath="url(#linkedin-grey_svg__a)">
      <path
        fill="#B5AEAB"
        d="M22.228.018H1.772A1.77 1.77 0 0 0 0 1.789v20.457a1.77 1.77 0 0 0 1.772 1.772h20.456A1.77 1.77 0 0 0 24 22.246V1.789A1.77 1.77 0 0 0 22.228.018M7.153 20.463H3.545V9h3.608zM5.347 7.413a2.072 2.072 0 1 1 2.083-2.07 2.04 2.04 0 0 1-2.083 2.07m15.106 13.06h-3.606V14.21c0-1.847-.785-2.417-1.799-2.417-1.07 0-2.12.807-2.12 2.464v6.215H9.32V9.009h3.47v1.589h.047c.348-.705 1.568-1.91 3.43-1.91 2.013 0 4.188 1.195 4.188 4.695z"
      />
    </g>
    <defs>
      <clipPath id="linkedin-grey_svg__a">
        <path
          fill="#fff"
          d="M0 .018h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLinkedinGrey;
